import { Business, QueryBuilder } from '@mui/icons-material'
import { Box, Card, CardActions, CardContent, CardMedia, Chip, Typography } from '@mui/material'
import { styled } from '@mui/system'
import { memo } from 'react'
import { Courses } from '../../models/course'

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  transition: 'box-shadow 0.3s ease',
  width: 280,
  height: 330,
  '&:hover': { boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.2)' }
}))

const StyledCardMedia = styled(CardMedia)(() => ({
  height: 160,
  position: 'relative',
  cursor: 'pointer',
  objectFit: 'cover'
}))

const TagsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2)
}))

type CourseCardProps = { course: Courses }

function CourseCard({ course }: CourseCardProps) {
  return (
    <StyledCard>
      <StyledCardMedia image={`${course.image_url}?${Date.now()}`} title={course.title} />
      <CardContent>
        <Box>
          <Typography variant="subtitle2" component="div" gutterBottom>
            {course.title}
          </Typography>
          {course.duration !== 0 && (
            <Box display="flex" alignItems="center" gap={1} mt={1}>
              <QueryBuilder fontSize="small" color="action" />
              <Typography variant="body1" color="text.secondary">
                Duración: {course.duration} min
              </Typography>
            </Box>
          )}
          <TagsContainer>
            {Array.isArray(course.tags) &&
              course.tags.map((tag, index) => <Chip key={index} label={tag} size="small" />)}
          </TagsContainer>
        </Box>
      </CardContent>
      <CardActions sx={{ padding: 0, justifyContent: 'space-between' }} disableSpacing>
        <Box display="flex" alignItems="center" gap={1} pr={2} ml="auto" mb={2}>
          <Business fontSize="small" color="action" />
          <Typography variant="body2" color="text.secondary">
            {course?.brand?.name}
          </Typography>
        </Box>
      </CardActions>
    </StyledCard>
  )
}

export default memo(CourseCard)
